import {FormControl, MenuItem, Select} from "@mui/material";
import {BREAKDOWN_VIEWS} from "../utils/filters";

export const MEASURE_DETAIL_GROUP_BY_OPTIONS = [
    {value: BREAKDOWN_VIEWS.CUSTOMERS, label: 'Customers'},
    {value: BREAKDOWN_VIEWS.PRODUCTS, label: 'Products'},
    {value: BREAKDOWN_VIEWS.SALES_REPS, label: 'Sales Reps'}
];

export const MeasureDetailGroupBySelect = ({
    value,
    onChange,
    minWidth = 180
}) => (
    <FormControl size="small" sx={{minWidth}}>
        <Select
            value={value || BREAKDOWN_VIEWS.CUSTOMERS}
            onChange={(e) => onChange?.(e.target.value)}
        >
            {MEASURE_DETAIL_GROUP_BY_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </Select>
    </FormControl>
);
